import React, { useEffect, useState, useRef } from 'react';
import ButtonSpinner from '../../layout/ButtonSpinner';
import { Button, Modal, Form } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
import { v4 as uuidv4 } from 'uuid';
//Función principal
const InterveningFormModal = props => {
    //Tomo los props
    const { show, handleClose, isEdit, intervenings, setIntervenings, characters } = props;
    //Genero los refs
    const refApellido = useRef();
    //Datos iniciales
    const initialData = {
        index: uuidv4(),
        apellido: '',
        nombre: '',
        caracter: '',
        domicilio: '',
        email: '',
        telefono: ''
    }
    useEffect(() => {
        setIntervening(initialData);
    }, []);
    //Inicializo el state local
    const [ intervening, setIntervening ] = useState(initialData);
    const [ loading, setLoading ] = useState(false);
    //Manejo de cambios
    const handleChange = e => {
        setIntervening({
            ...intervening,
            [e.target.name]: e.target.value
        })
    }
    //Manejo el guardado
    const handleSave = values => {
        //Evalúo el caracter seleccionado
        const character = characters.find(c => c.id === parseInt(values.caracter));
        //Armo el objeto de datos
        let data = {
            index: intervening.index,
            persona: {
                apellido: values.apellido,
                nombre: values.nombre
            },
            domicilio: values.domicilio,
            email: values.email,
            telefono: values.telefono,
            caracter: {
                id: values.caracter,
                descripcion: character ? character.descripcion : ''
            }
        }
        //Lo agrego a los acusados
        setIntervenings([
            ...intervenings,
            data
        ]);
        //Cierro la ventana
        handleCloseForm();
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setIntervening(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        caracter: yup.number().required()
    });
    //Renderizo
    return (
        <Modal 
            show={show} 
            onHide={handleCloseForm} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
            size="lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Interviniente&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...intervening }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Complete todos los datos correspondientes a el INTERVINIENTE.
                                    </div>
                                </div>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="apellido"
                                        className="form-control" 
                                        autoFocus 
                                        name="apellido" 
                                        type="text" 
                                        placeholder="Apellido"
                                        value={ values.apellido }
                                        onChange={handleChange}
                                        ref={refApellido}
                                        isInvalid={!!errors.apellido}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="nombre"
                                        className="form-control" 
                                        name="nombre" 
                                        type="text" 
                                        placeholder="Nombre"
                                        value={ values.nombre }
                                        onChange={handleChange}
                                        isInvalid={!!errors.nombre}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        as="select"
                                        id="caracter"
                                        className="form-control"  
                                        name="caracter"  
                                        value={ values.caracter }
                                        onChange={handleChange}
                                        isInvalid={!!errors.caracter}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccione caracter</option>
                                        {
                                            characters.map(character => (
                                                <option value={character.id} key={`ifc${character.id}`}>
                                                    { character.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.caracter }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <Form.Control
                                        id="telefono"
                                        className="form-control" 
                                        name="telefono" 
                                        type="text" 
                                        placeholder="Teléfono"
                                        value={ values.telefono }
                                        onChange={handleChange}
                                        isInvalid={!!errors.telefono}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.telefono }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <Form.Control
                                        id="email"
                                        className="form-control" 
                                        name="email" 
                                        type="text" 
                                        placeholder="Email"
                                        value={ values.email }
                                        onChange={handleChange}
                                        isInvalid={!!errors.email}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-8">
                                    <Form.Control
                                        id="domicilio"
                                        className="form-control" 
                                        name="domicilio" 
                                        type="text" 
                                        placeholder="Domicilio"
                                        value={ values.domicilio }
                                        onChange={handleChange}
                                        isInvalid={!!errors.domicilio}
                                        disabled={ loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.domicilio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>AGREGAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default InterveningFormModal;